import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
	state: {
		content: [],
		gemeenteAlle: null,
		loading: true,
		gemeenteSelected: null,
		buurtSelected: null,
		userLocation: undefined,
		buurtScenario: null
	},
	getters: {
		gemeenteAlle(state) {
			return state.gemeenteAlle;
		},
		
		gemeenteSelected(state) {
			return state.gemeenteSelected;
		},

		buurtSelected(state) {
			return state.buurtSelected;
		},

		userLocation(state) {
			return state.userLocation;
		},

		buurtScenario(state) {
			return state.buurtScenario;
		}
	},
	mutations: {
		SAVE_CONTENT (state, data) {
			state.content = data;
			state.loading = false;
		}, 

		SAVE_LIJST (state, data) {
			state.gemeenteAlle = data;

			let features = state.gemeenteAlle.objects.gemeenten2019_zz.geometries;

			features.sort((a,b) => {
				if(a.properties.GM_NAAM < b.properties.GM_NAAM) { return -1; }
				if(a.properties.GM_NAAM > b.properties.GM_NAAM) { return 1; }
				return 0;
			});

			state.gemeentenAutocomplete = features.map((d, index) => {
				return {label: d.properties.GM_NAAM, value: index, code: d.properties.GM_CODE}
			});
		}, 

		SAVE_GEMEENTE(state, data) {
			state.gemeenteSelected = data;
		},

		SET_BUURT(state, buurt) {
			state.buurtSelected = buurt;

			if (buurt.buurt_ongezond_2021 > 0 || buurt.buurt_ongezond_2011 > 0) {
				if (buurt.buurt_ongezond_verschil < 0) { //daling ongezond
					state.buurtScenario = "daling";
				}
				else { //stijging of gelijk ongezond
					state.buurtScenario = "stijging"
				}
			}
			else { //geen ongezonde locaties
				state.buurtScenario = "geen";
			}
		},

		SET_LOCATION(state, data) {
			state.userLocation = data;
		},

		SET_SCENARIO(state, scenario) {
			state.buurtScenario = scenario
		}
	},
	actions: {
		loadData ({ commit, state }) {
			return new Promise((resolve, reject) => { 
				if(state.content.length > 0) {
					resolve();
					return;
				}

				// console.log(process.env.BASE_URL);
				// debugger;

				// axios.get("https://data.kro-ncrv.nl/data/copy/2021-vet-omgeving.json")
				// .then(d => {
				// 	debugger;
				// })
				// .catch(error => {
				// 		reject();
				// 		throw new Error(`API ${error}`);
				// });

				axios
					.all([
						axios.get("https://data.kro-ncrv.nl/data/copy/2021-vet-omgeving.json"),
						axios.get(process.env.BASE_URL + "data/gemeenten/gemeenten2019_topo.json")
					])
					.then((content, gemeenteAlle) => {
						commit("SAVE_CONTENT", content[0].data);
						commit("SAVE_LIJST", content[1].data);
						this.state.loading = false;
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			})
		},

		loadGemeente({ commit, state }, gemeente) {
			return new Promise((resolve, reject) => { 
				if(state.content.length > 0) {
					resolve();
					return;
				}

				axios
					.get(process.env.BASE_URL + "data/gemeenten/" + gemeente.code + ".json")
					.then(result => {
						commit("SAVE_GEMEENTE", result.data);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			})
		},

		updateBuurt({ commit }, buurt) {
			commit("SET_BUURT", buurt);
		},

		updateUserLoc({ commit }, arr) {
			commit("SET_LOCATION", arr);
		},

		updateBuurtScenario({ commit }, scenario) {
			commit("SET_SCENARIO", scenario);
		}
	},
	modules: {

	}
})
